import React from 'react'

import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableCellStyled,
  TableBodyStyled,
  TableFooter
} from 'components'
import { IHandleChangePage, IHandleChangeRowsPerPage } from 'hooks/useGet'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { IGraduacaoMultasGetAllHistoricoValorUnidadeUFIRResponse } from 'services/GST/GraduacaoMultas'
import { FORMAT } from 'utils'

interface ITableHistoricoValorUnidadeUFIRProps {
  data: IPaginatedEntityGST<IGraduacaoMultasGetAllHistoricoValorUnidadeUFIRResponse[]>
  handleChangePage: IHandleChangePage
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
  page: number
  rowsPerPage: number
}

const TableHistoricoValorUnidadeUFIR: React.FC<ITableHistoricoValorUnidadeUFIRProps> = ({
  data,
  handleChangePage,
  handleChangeRowsPerPage,
  page,
  rowsPerPage,
}) => {
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left" minwidth="20px">
                Valor Unidade UFIR
              </TableCellStyled>
              <TableCellStyled align="center" minwidth="20px">
                Portaria
              </TableCellStyled>
              <TableCellStyled align="center" minwidth="20px">Data Atualização</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {data?.entity?.items.map((row) => (
              <TableRowStyled
                key={`${row.idUnidadeUFIR}`}
              >
                <TableCellStyled align="left">{FORMAT.currency(row.vlUnidadeUFIR) || '---'}</TableCellStyled>
                <TableCellStyled align="center">
                  {row.portaria || '---'}
                </TableCellStyled>
                <TableCellStyled align="center">{
                  FORMAT.formatMMYYYYWithValueMask(row.dataAtualizacao) !== 'Data inválida' ? FORMAT.formatMMYYYYWithValueMask(row.dataAtualizacao)
                    : row.dataAtualizacao || '---'
                }</TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={data?.entity?.items}
        totalItems={data?.entity?.pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default TableHistoricoValorUnidadeUFIR
